<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <ul>
            <li v-for="item in list" :key="item.id" class="li-item">
              <div
                v-if="item.outerSiteUrl == null || item.outerSiteUrl == ''"
                class="licontent"
                @click="goDetail(item.id)"
              >
                <div class="group_news_left">
                  <h2 class="group_news_title">{{ item.title }}</h2>
                  <!-- <h4>111</h4> -->
                  <div class="content" v-if="item.showContent">
                    {{ item.showContent }}
                  </div>
                </div>
                <div class="group_news_right">
                  <div class="group_news_right">{{ item.createTime }}</div>
                  <div class="group_news_right_j">
                    <img src="@/assets/images/icon_h_youjiantou.png" alt="" />
                  </div>
                </div>
              </div>
              <a
                :href="item.outerSiteUrl"
                v-if="item.isOuterSite == 0 && item.outerSiteUrl"
                target="_blank"
              >
                <div class="group_news_left">
                  <h2 class="group_news_title">{{ item.title }}</h2>
                  <!-- <h4>111</h4> -->
                  <div class="content" v-if="item.showContent">
                    {{ item.showContent }}
                  </div>
                </div>
                <div class="group_news_right">
                  <div class="group_news_right">{{ item.createTime }}</div>
                  <div class="group_news_right_j">
                    <img src="@/assets/images/icon_h_youjiantou.png" alt="" />
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      list: [],

      pagination: {
        pagingData: [10, 50, 100, 200],
        total: 0,
        currentPage: 1,
        show: true,
      },
      search: {
        page: 1,
        size: 10,
      },
      currentPage1: 1,
      ssqyPage:''
    };
  },
  computed: {},
  watch: {},
  created() {
    this.ssqyPage = JSON.parse(localStorage.getItem("ssqyPage"));
    this.currentPage1 = this.ssqyPage;
    this.pagination.currentPage = this.ssqyPage;
    this.search.page = this.ssqyPage;
    this.getSsqyList();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    goDetail(id) {
      // this.$router.push("/xxgkDetail?index=" + id);
      this.$router.push({
        path: "/xxgkDetail",
        query: { index: id, ssqyPage: this.currentPage1},
      });
    },
    getSsqyList() {
      let params = {
        pageNum: this.search.page,
        pageSize: this.search.size,
        menuId: 9,
      };
      axios.get("/jtg/home/articleList", { params }).then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.list = res.data.items;
        console.log(res.data, 222);
        this.pagination.total = res.data.total;
        // console.log(res.data, 7777);
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.search.size = val;

      this.pagination.currentPage = 1;
      this.currentPage1 = 1;
      this.search.page = 1;
      this.getSsqyList();
    },
    handleCurrentChange(val) {
      let x = document.getElementById("app");
      x.scrollTop = 0;
      this.pagination.currentPage = val;
      this.currentPage1 = val;
      this.search.page = val;
      this.getSsqyList();
    },
  },
};
</script>
<style lang='scss' scoped>
// .detail {
//   cursor: pointer;
//   display: flex;
// }
.mgb80 {
  margin-bottom: 80px;
  margin-top: 0px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;

    .inner_content_right {
      .li-item {
        width: 100%;
        height: 202px;
        background: #ffffff;
        border-bottom: 1px solid #e5e5e5;
        padding: 48px 103px 20px 40px;
        box-sizing: border-box;
        .detail {
          width: 100%;
          height: 100%;
          display: block;
          cursor: pointer;
          .group_news_left {
            float: left;
            width: 80%;
            .group_news_title {
              font-size: 18px;
              font-weight: bold;
              color: #333333;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .group_news_right {
            float: right;
            font-size: 24px;
            font-weight: 400;
            color: #999999;
            .group_news_right_j {
              line-height: 26px;
              margin-top: 60px;
            }
          }
        }
      }
      .licontent {
        cursor: pointer;
        width: 100%;
        height: 100%;
        display: block;
        .group_news_left {
          float: left;
          width: 80%;
          .group_news_title {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .group_news_right {
          float: right;
          font-size: 24px;
          font-weight: 400;
          color: #999999;
          .group_news_right_j {
            line-height: 26px;
            margin-top: 60px;
          }
        }
      }
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>